export default [
   // 交易對設定
  {
    path: "/tradingPair/settings",
    component: () => import(/* webpackChunkName: "home" */ "@/views/TradingPair/TradingPairSettings"),
    name: "pair-forex-manage",
    meta: { keepAlive: false },
  }
]